//@flow
import {
  ACTION_SEEN,
  ACTION_SET,
  ACTION_GET_NEW_ONE_REQUEST,
  ACTION_UNSET,
  ACTION_UNSEEN,
  ACTION_SET_NEXT,
  ACTION_COMMENT_CHANGE,
  ACTION_RATING_CHANGE,
  ACTION_NEXT_CATEGORY_CHANGE,
  ACTION_FEEDBACK_SUBMIT_REQUEST,
  ACTION_DONE_PERCENTAGE_CHANGE,
  ACTION_FEEDBACK_ACTION_DONE_CHANGE,
  ACTION_DONE_REQUEST,
  ACTION_GET_ADMIN_REQUEST,
  ACTION_CANT_DO_REQUEST,
  ACTION_CHANGE,
  ACTION_FEEDBACK_SHARED_STATE,
  ACTION_FEEDBACK_SHARED_STATE_RESET,
  CHANGE_SEE_ACTION_AGAIN,
  CHANGE_ANALYSIS_TYPE,
} from "./constants";
import { AnalysisType } from "./types";

// le changeActionState, on devrait faire un type pour les points et le ranking, et ainsi faire une fonction qui permette de modifier juste le score
// cette fonction modifie tout et n'importe quoi
export const changeActionState = (payload: {
  actionState?: string;
  seeActionAgain?: boolean;
  oldTeamPoints?: number;
  oldUserPoints?: number;
  oldRank?: number;
  oldTeamRank?: number;
}) => {
  return {
    type: ACTION_CHANGE,
    payload,
  };
};

// utilisé ?
export const seeAction = (payload: {
  userId: string;
  actionSeenDate: Date;
}) => {
  return {
    type: ACTION_SEEN,
    payload,
  };
};

// utilisé ?
export const doActionRequest = (payload: { feedback: {}; action: {} }) => {
  return {
    type: ACTION_DONE_REQUEST,
    payload,
    meta: {
      retry: true,
    },
  };
};

// utilisé ?
export const unseeAction = () => {
  return {
    type: ACTION_UNSEEN,
  };
};

export const setAction = payload => {
  return {
    type: ACTION_SET,
    payload,
  };
};

// utilisé ?
export const unsetAction = () => {
  return {
    type: ACTION_UNSET,
  };
};

// utilisé ?
export const setNextAction = payload => {
  return {
    type: ACTION_SET_NEXT,
    payload,
  };
};

export const changeComment = (payload: string) => {
  return {
    type: ACTION_COMMENT_CHANGE,
    payload,
  };
};

// utilisé ?
export const changeNextCategory = (payload: {
  userId: string;
  nextCategory: string;
}) => {
  return {
    type: ACTION_NEXT_CATEGORY_CHANGE,
    payload,
  };
};

export const changeDonePercentage = (payload: number) => {
  return {
    type: ACTION_DONE_PERCENTAGE_CHANGE,
    payload,
  };
};

export const changeRating = (payload: number) => {
  return {
    type: ACTION_RATING_CHANGE,
    payload,
  };
};

// utilisé ?
export const changeActionDone = (payload: boolean) => {
  return {
    type: ACTION_FEEDBACK_ACTION_DONE_CHANGE,
    payload,
  };
};

// utilisé ?
export const submitFeedback = (payload: {
  userId: string;
  actionId: string;
  rating: number;
  comment: string;
}) => {
  return {
    type: ACTION_FEEDBACK_SUBMIT_REQUEST,
    payload,
    meta: {
      retry: true,
    },
  };
};

// utilisé ?
export const getNewAction = (payload: { userId: string; actionId: string }) => {
  return {
    type: ACTION_GET_NEW_ONE_REQUEST,
    payload,
  };
};

// utilisé ?
export const getAdminActionRequest = (payload: { humanId: string }) => {
  return {
    type: ACTION_GET_ADMIN_REQUEST,
    payload,
  };
};

export const cantDoActionRequest = (payload: { userId: string }) => {
  return {
    type: ACTION_CANT_DO_REQUEST,
    payload,
  };
};

export const changeActionFeedbackSharedState = (payload: {
  isShared: boolean;
}) => {
  return {
    type: ACTION_FEEDBACK_SHARED_STATE,
    payload,
  };
};

export const resetActionFeedbackSharedState = () => {
  return {
    type: ACTION_FEEDBACK_SHARED_STATE_RESET,
  };
};

export const changeSeeActionAgain = (payload: boolean) => {
  return {
    type: CHANGE_SEE_ACTION_AGAIN,
    payload,
  };
};

export const changeAnalysisType = (payload: AnalysisType) => {
  return {
    type: CHANGE_ANALYSIS_TYPE,
    payload,
  }
}